export const padZeroLeft = (num: number, length: number) => {
    let str = '' + num;
    while (str.length < length) {
        str = '0' + str;
    }
    return str;
};
